import styled from "styled-components";
import { swiperOutsidePagination, sectionTitle, footerText } from "../../styles/mixins";

export const Container = styled.section`
  margin-top: 5rem;

  ${sectionTitle}
  ${footerText}
  ${swiperOutsidePagination}

  .projects {
    /* no grid: cards are inside Swiper slides */
    padding: 0;
    }
  }

  &.main {
    margin-top: 0;
    padding-top: 85px;
  }

  .footer-portfolio {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    }

  
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 3.6rem;
    height: 3.6rem;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      filter: brightness(0.95);
      transition: transform 0.2s ease, filter 0.2s ease;
    }
  }

  /* Responsive handled by Swiper breakpoints */
`;

export const Accordion = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  place-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  color: black;

  button {
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75%;
    gap: 2rem;
    background-color: var(--green);
    border-radius: 1.4rem;
    padding: 1.6rem 2.8rem;
    transition: background-color 0.25s;

    &:hover{
      background-color: var(--pink);
      color: #FFF;
    }
  }
`;
